import { render, staticRenderFns } from "./wasteExchangeBedConfirm.vue?vue&type=template&id=6189c426&scoped=true&"
import script from "./wasteExchangeBedConfirm.vue?vue&type=script&lang=js&"
export * from "./wasteExchangeBedConfirm.vue?vue&type=script&lang=js&"
import style0 from "./wasteExchangeBedConfirm.vue?vue&type=style&index=0&id=6189c426&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6189c426",
  null
  
)

export default component.exports